import { SearchMenuHelper } from "@/Common/Helpers/SearchMenuHelper";
import { Person } from "@/Common/Models/Person/Person";
import { SiteUIModel } from "@/Common/Models/Sites/SiteUIModel";
import { EmployeeUIModel } from "@/Common/Models/UI/Employee/EmployeeUIModel";
import { PersonDropdownItem } from "@/Common/Models/UI/Inputs/PersonDropdownItem";

class EmployeeHelper {
    public static filterCliniciansBySearchText(clinicians: EmployeeUIModel[], searchText: string, showDeactivatedClinicians: boolean = false): EmployeeUIModel[] {
        const matchedClinicians = clinicians
            .filterSearch(searchText.trim(), employee => employee.Name);

        return showDeactivatedClinicians
            ? matchedClinicians
            : matchedClinicians.filter(p => !p.isInactive());
    }

    public static filterCliniciansByCheckedSites(clinicians: EmployeeUIModel[], sites: SiteUIModel[]): EmployeeUIModel[] {
        const checkedSiteIds = (sites || [])
            .filter(site => site.Checked)
            .map(site => site.Id);

        return SearchMenuHelper
            .FilterCliniciansMembersOfSites(clinicians.toImmutable(), checkedSiteIds)
            .toArray();
    }

    public static selectClinician(selectedClinicians: Person[], clinician: PersonDropdownItem): Person[] {
        if (!clinician?.Item)
            return selectedClinicians;

        let clinicianGroup: Person[];

        if (clinician.Item.IsPersonGroup) {
            if (clinician.Item.EmployeeGroupModel?.EmployeeContactFacetIds.length <= 20) {
                clinicianGroup = clinician.Item.EmployeeGroupModel?.EmployeeContactFacetIds.map(id => cacheStore.GetCliniciansPersonsByContactFacetIdOrEmpty(id));
            }
            else if (selectedClinicians.indexOf(clinician.Item) == -1) {
                selectedClinicians.push(clinician.Item);
                return selectedClinicians;
            }
        }

        if (selectedClinicians.indexOf(clinician.Item) == -1
            && !clinician.Item.IsPersonGroup
            && !selectedClinicians.any(existingCl => existingCl.ContactFacetId === clinician.Item.ContactFacetId)
        ) {
            selectedClinicians.push(clinician.Item);
        }

        if (clinicianGroup?.any()) {
            clinicianGroup.forEach(cl => {
                if (!selectedClinicians.any(existingCl => existingCl.ContactFacetId === cl.ContactFacetId))
                    selectedClinicians.push(cl);
            });
        }
        return selectedClinicians;
    }
}

export { EmployeeHelper };
